import {
  ICheckbookCard,
  PayoutDestinationType
} from "@wingspanhq/payments/dist/interfaces";
import { AxiosError } from "axios";
import React from "react";
import { AddDebitCardForm } from "../../../components/AddDebitCardForm/AddDebitCardForm";
import { OverlaySpinner } from "../../../components/OverlaySpinner";
import { SetupFlowRouteComponentProps } from "../../../components/SetupFlow/SetupFlow";
import { SetupLayout } from "../../../components/SetupFlow/SetupFlowLayout";
import { useWSMutation } from "../../../query/helpers";
import { useUserId } from "../../../query/hooks/helpers";
import { QUERY_PAYOUT_SETTINGS } from "../../../query/payments/keys";
import { paymentsService } from "../../../services/payments";

export const AddInstantPayoutMethodDebit: React.FC<SetupFlowRouteComponentProps> = ({
  onBack,
  onNext
}) => {
  const userId = useUserId();

  const [submit, submitMeta] = useWSMutation<
    any,
    AxiosError,
    { debitCard: ICheckbookCard }
  >(
    async ({ debitCard }) => {
      return await paymentsService.payoutSettings.update(userId, {
        instant: {
          destinationId: debitCard.cardId,
          destinationType: PayoutDestinationType.Card
        }
      });
    },
    {
      dependencies: [QUERY_PAYOUT_SETTINGS],
      onSuccess: onNext
    }
  );

  return (
    <SetupLayout title="Enter your debit card info" onBack={onBack}>
      <AddDebitCardForm
        onSubmit={debitCard => {
          submit({ debitCard });
        }}
      />

      {submitMeta.isLoading && <OverlaySpinner />}
    </SetupLayout>
  );
};
